import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	title: {
		'id': 'surveyGreeting.title',
		'defaultMessage': 'Help to improove growering experience',
	},
	subtitle: {
		'id': 'surveyGreeting.subtitle',
		'defaultMessage': 'Why wouldn\'t you take a part at interesting survey! Help to improove growering experience.',
	},
	emailInValid:{
		'id': 'surveyGreeting.emailInValid',
		'defaultMessage': 'The input is not valid E-mail!',
	},
	email:{
		'id': 'surveyGreeting.email',
		'defaultMessage': 'Please input your E-mail!',
	},
	placeholder:{
		'id': 'surveyGreeting.placeholder',
		'defaultMessage': 'Enter your email to subscribe for news',
	},
	button:{
		'id': 'surveyGreeting.resultButton',
		'defaultMessage': 'Start Survey!',
	}
});


// WEBPACK FOOTER //
// ./src/components/SurveyGreeting/messages.js